export const APP_VERSION = 'v1.013'

export function VersionFooter() {
  return (
    <footer className="fixed bottom-0 left-0 right-0 z-40 flex h-8 items-center justify-center border-t border-slate-800/50 bg-slate-950/80 backdrop-blur-sm">
      <p className="text-xs text-slate-500">
        AlertWhale Dashboard {APP_VERSION}
      </p>
    </footer>
  )
}
